import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";
import { Box } from "@material-ui/core";

import { FlashSms } from "./components/FlashSms";
import { RaffleParticipantStat } from "./components/RaffleParticipantStat";
import { PushNotification } from "./components/PushNotification";
import ExpandedContent from "../../../../components/ExpandedContent";
import Grid from "@material-ui/core/Grid";

interface RaffleDrawResumeProps {}

const useStyles = makeStyles(
  (theme) => ({
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "nowrap",
      padding: "20px 32px",
    },
  }),
  { name: "icip-raffle-draw-", flip: null }
);

export const RaffleDrawResume = (props: RaffleDrawResumeProps) => {
  const classes = useStyles();

  return (
    <>
      <Box component="div" pb={6}>
        <Box component="div">
          <Box component="div" className={classes.header} mb={2}>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="sharedScreen.statAndOthers" />
            </Typography>
          </Box>

          <Box component="div" mb={6}>
            <ExpandedContent
              title="Flash SMS & Push Notification"
              defaultExpanded={false}
              withPadding
            >
              <Box component="div" mb={2}>
                <Grid container spacing={6}>
                  <Grid item sm={6}>
                    <FlashSms />
                  </Grid>
                  <Grid item sm={6}>
                    <PushNotification />
                  </Grid>
                </Grid>
              </Box>
            </ExpandedContent>
            <RaffleParticipantStat />
          </Box>
        </Box>
      </Box>
    </>
  );
};
